import script from "./ForgetPassword.vue?vue&type=script&setup=true&lang=js"
export * from "./ForgetPassword.vue?vue&type=script&setup=true&lang=js"

import "./ForgetPassword.vue?vue&type=style&index=0&id=c9f550f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c9f550f8"]])

export default __exports__